/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Container from '@/components/Container';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import React from 'react';
import DefaultContentTemplateEmbedded from '@/components/DefaultContentTemplate/Embedded';
import { GENERATED } from '@edwin-group/cj-graphql';
import type { Course } from '@edwin-group/cj-graphql/generated/graphql';
import TitleWithActions from '@/components/TitleWithActions';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

export default function Highlight({
  image,
  video,
  title = '',
  description = '',
  button = '',
  category,
  cx,
}: {
  image?: string;
  video?: string;
  title?: string;
  description?: string;
  button?: React.ReactNode;
  category: GENERATED.Enum_Bookmark_Category;
  cx: Course | null;
}) {
  const { src } = useResponsiveImage({ url: image || '', alternativeText: '' });

  if (!cx) {
    return null;
  }

  if (video) {
    return (
      <AnimatedFadeInComponent>
        <Container>
          <div className="col-span-12 lg:col-start-3 lg:col-end-11">
            <div className="relative flex flex-col gap-sh-15">
              <DefaultContentTemplateEmbedded
                className="mindful-video !my-0"
                fitContent
                // @ts-expect-error DEPRECATED_STRAPI_ATTRIBUTES
                component={{
                  id: 'DefaultContentTemplateEmbedded',
                  link: video,
                  provider: GENERATED.Enum_Componentcommonembedded_Provider.Youtube,
                }}
              />
              <TitleWithActions
                title={title || ''}
                entity={cx}
                entityId={cx?.documentId || '0'}
                category={category}
                like={false}
              />
              <p className="mt-0 font-cadiz text-sh-18-28">{description}</p>
              {button}
            </div>
          </div>
        </Container>
      </AnimatedFadeInComponent>
    );
  }

  return (
    <AnimatedFadeInComponent>
      <Container>
        <div className="col-span-12 flex flex-col items-start lg:col-start-11 lg:col-end-3">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-[415px_1fr]">
            <div className="flex aspect-video items-center justify-center overflow-hidden rounded-2xl md:aspect-square">
              <img
                className="h-full max-h-[415px] w-full rounded-2xl object-cover object-center"
                src={src || ''}
                alt={src || ''}
              />
            </div>
            <div>
              <TitleWithActions
                title={title || ''}
                entity={cx}
                entityId={cx?.documentId || '0'}
                category={category}
                like={false}
              />
              <p className="mb-sh-15 mt-2 font-cadiz text-sh-16-24">{description}</p>
              {button}
            </div>
          </div>
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
